// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u2kVRhlWz8wfA_XBNe3H{flex-direction:column;flex-grow:1;height:100%;display:flex}.RbZDwESEnkcSViFg9SJS{padding-left:12px}.z7i4kmqw_LkX0vreeFpz{flex-grow:1;margin-left:16px;display:flex;position:relative}.lx7FRYi50wG65azejZTX{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `u2kVRhlWz8wfA_XBNe3H`,
	"search": `RbZDwESEnkcSViFg9SJS`,
	"table": `z7i4kmqw_LkX0vreeFpz`,
	"inboxCellContainer": `lx7FRYi50wG65azejZTX`
};
export default ___CSS_LOADER_EXPORT___;
